import api from "./axiosInstance";

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const deleteFoto = async (id: string): Promise<{ message: string }> => {
  const res = await api.delete(
    `${process.env.REACT_APP_API_URL}/foto/delete?id=${id}`,
    { headers: getAuthHeader() }
  );
  return res.data;
};